module.exports = __webpack_public_path__ + "img/shagufta.23d6dcdb.jpeg";